import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { getTuinaPurchaseOrderList } from '@/service/tuina'

export const fetchTuinaPurchaseOrderList = createAsyncThunk(
  'tuinaPurchaseOrderList/fetchTuinaPurchaseOrderList',
  async ({ query = {} } = {}, { rejectWithValue }) => {
    try {
      const response = await getTuinaPurchaseOrderList(query)
      return {
        data: response.data,
        query
      }
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.msg ||
          error?.response?.data?.message ||
          error?.msg ||
          error?.message ||
          '加载订单失败'
      )
    }
  }
)

const purchaseOrderListSlice = createSlice({
  name: 'tuinaPurchaseOrderList',
  initialState: {
    fetching: false,
    error: null,
    query: {},
    data: {}
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTuinaPurchaseOrderList.pending, (state) => {
        state.fetching = true
        state.error = null
      })
      .addCase(fetchTuinaPurchaseOrderList.fulfilled, (state, action) => {
        state.fetching = false
        state.error = null
        state.query = action.payload.query
        state.data = action.payload.data || {}
      })
      .addCase(fetchTuinaPurchaseOrderList.rejected, (state, action) => {
        state.fetching = false
        state.error = action.payload ?? action.error?.message ?? null
      })
  }
})

export default purchaseOrderListSlice.reducer
